/* eslint
 wrap-iife: 1,
 global-require:1,
 no-param-reassign:1,
 no-underscore-dangle:1,
 no-else-return:1,
 new-cap:1,
 camelcase:1,
 no-invalid-this:1
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define([
            'bam-moment-i18n/index',
            'pageMeta/pageMeta'
        ], factory);
    } else if (typeof exports === 'object') {
        // Node, CommonJS-like
        module.exports = factory(
            require('bam-moment-i18n/index'),
            null,
            require('i18n-2'),
            require('lodash')
        );
    } else {
        // Browser globals (root is window)
        root.BamHbsHelpers = factory(
            root.bamMoment,
            null,
            null
        );
    }
})(this, function (bamMoment, pageMeta, i18n, _) {
    'use strict';

    var _i18n;
    var BamHbsHelpers = {
        locale: 'en',
        helpers: {
            encodedjson: function (obj) {
                if (obj === null || typeof obj === 'undefined' ||
                    typeof(obj) === 'function' || typeof obj === 'boolean') {
                    return encodeURIComponent(JSON.stringify({}));
                }
                return encodeURIComponent(JSON.stringify(obj));
            },
            safejson: function (obj) {
                // replaces < and > characters with charCodes
                function replaceCarets(r) {
                    return r.replace(/[<>]/g, function (rInner) {
                        return '&#' + rInner.charCodeAt(0) + ';';
                    });
                }

                return (obj) ? replaceCarets(JSON.stringify(obj)) : '{}';
            },
            json: function (obj) {
                if (obj === null || typeof obj === 'undefined' ||
                    typeof(obj) === 'function' || typeof obj === 'boolean') {
                    return JSON.stringify({});
                }
                return JSON.stringify(obj);
            },
            equals: function (one, two, options) {
                //{{equals one two}} {{else}} {{/equals}}
                if (one === two) {
                    return options.fn(this);
                }
                return options.inverse(this);
            },
            join: function (array, sep) {
                if (_.isArray(array) && _.isString(sep)) {
                    return array.join(sep);
                }
                return '';
            },
            ismore: function (arr, threshold, options) {
                //{{ismore this.items 50}} {{else}} {{/ismore}}
                if (arr && arr.length > threshold) {
                    return options.fn(this);
                }
                return options.inverse(this);
            },
            math: function (lvalue, operator, rvalue) {
                lvalue = parseFloat(lvalue);
                rvalue = parseFloat(rvalue);
                return {
                    '+': lvalue + rvalue,
                    '-': lvalue - rvalue,
                    '*': lvalue * rvalue,
                    '/': lvalue / rvalue,
                    '%': lvalue % rvalue
                }[operator];
            },
            ifin: function (elem, list, options) {
                //{{ifin 'All' ['All', 'Action']}}{{else}}{{/ifin}}
                if (list && list.indexOf(elem) > -1) {
                    return options.fn(this);
                }
                return options.inverse(this);
            },
            formatDate: function (date, format) {
                var output = '';
                if (typeof date !== 'boolean' && date !== null) {
                    date = new Date(date);
                }

                if (Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime())) {
                    date = new Date(date.toUTCString()).toISOString();
                    output = bamMoment.moment(date).tz('America/New_York').format(format);
                }

                return output;
            },
            dateFromNow: function (date, withoutSuffix) {
                withoutSuffix = typeof withoutSuffix === 'object' ? false : withoutSuffix;
                return bamMoment.moment(date).fromNow(withoutSuffix);
            },
            dateToNow: function (date, withoutPrefix) {
                withoutPrefix = typeof withoutPrefix === 'object' ? false : withoutPrefix;
                return bamMoment.moment(date).toNow(withoutPrefix);
            },
            formatDuration: function (duration) {
                duration = duration || '00:00';

                while (duration.indexOf('00:') === 0 && duration.length > 5) {
                    duration = duration.substr(3);
                }
                return duration;
            },
            and: function (a, b, options) {
                if (a && b) {
                    return options.fn(this);
                } else {
                    return options.inverse(this);
                }
            },
            build: function (globalConfig, sectionConfig, override, options) {
                if (typeof override !== 'undefined') {
                    if (override) {
                        return options.fn(this);
                    } else {
                        return options.inverse(this);
                    }
                } else {
                    if (globalConfig && sectionConfig) {
                        return options.fn(this);
                    } else {
                        return options.inverse(this);
                    }
                }
            },
            limit: function (arr, count) {
                //{{#each (limit my.arr 50)}}  used as subexpression to limit an each iteration.
                return arr.slice(0, count);
            },
            toLowerCase: function (str) {
                return (str) ? str.toLowerCase() : '';
            },
            toUpperCase: function (str) {
                return (str) ? str.toUpperCase() : '';
            },
            escapeSingleQuotes: function (str) {
                return (str && _.isString(str)) ? str.replace(/'/g, "\\\'") : str;
            },
            i18n: function (key, fallBackText) {
                return _i18n.__(key, fallBackText);
            },
            serverTime: function () {
                return bamMoment.moment().tz('America/New_York').format();
            },
            timeZoneOffset: function () {
                return bamMoment.moment().tz('America/New_York').format('Z');
            },
            safeNull: function (value, fallback) {
                if (value === null || value === '') {
                    return fallback;
                } else {
                    return value;
                }
            },
            setDomain: function (url, domain) {
                if ((url.indexOf('http') === 0 || url.indexOf('www') === 0) && typeof domain === 'string') {
                    url = url.substr(url.indexOf('.com') + 4);

                    if (url.charAt(0) !== '/') {
                        url = '/' + url;
                    }

                    if (domain !== 'relative') {
                        url = domain + url;
                    }
                }

                return url;
            },
            quoteescapedjson: function(obj) {
                function replaceQuotes(r) {
                    return r.replace(/"/g, '\&quot;');
                }
                return (obj) ? replaceQuotes(JSON.stringify(obj)) : '{}';
            }
        },
        setup_i18n: function (options) {
            //this will setup i18n function for the basesite
            //if a request object exists in the options obj
            if (options && options.i18n) {
                _i18n = options.i18n;
            } else {
                //setup i18n without a request object
                _i18n = new i18n({
                    locales: options.locales,
                    directory: options.directory || './templates/i18n',
                    extension: options.extension || '.json'
                });
            }
        },
        setup_i18n_external_data: function (res) {
            //setup for external dictionary files used in basesite
            //server side implementation without using i18n-2 module.
            if (res && res.locals.i18nDictionary) {
                _i18n = res.locals.i18nDictionary;
            }
        },
        setup_i18n_clientside: function (i18n_dict) {
            var i18nClient = function (i18n_dictionary) {
                this.dictionary = i18n_dictionary;
            };

            i18nClient.prototype = {
                __: function (key, fallBackText) {
                    return this.dictionary[key] ? this.dictionary[key] : (fallBackText || '');
                }
            };

            _i18n = new i18nClient(i18n_dict);
        },
        get_i18n: function () {
            return _i18n;
        }
    };

    // Private utility functions.

    /**
     * Set the locale client-side.
     */
    function setLocale() {
        if (pageMeta && pageMeta.locale) {
            //var locale = pageMeta.locale.toString();

            if (bamMoment.defaultConfig.supportedLocales.indexOf(pageMeta.locale) !== -1) {
                BamHbsHelpers.locale = pageMeta.locale;
            }

            bamMoment.setLocale(BamHbsHelpers.locale);
        }
    }

    setLocale();

    return BamHbsHelpers;
});
